"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryDropdown = exports.listingConst = exports.connectWithoutTAndC = exports.launchTAndC = exports.ReqInfo = exports.learnMoreSharedInfoLink = exports.needAnAccountLink = exports.connectLoyaltyNumber = exports.modal = exports.button = exports.termsAndConditions = exports.actionList = exports.elementList = exports.APPLICATION_NAME = exports.VALUES = exports.CONTEXTS = exports.TYPES = exports.EVENTS = void 0;
var EVENTS = {
  CLICK: 'CLICK'
};
exports.EVENTS = EVENTS;
var TYPES = {
  LISTING: 'LISTING',
  BUTTON: 'BUTTON',
  LINK: 'LINK'
};
exports.TYPES = TYPES;
var CONTEXTS = {
  HOME: 'HOME',
  LISTING_DETAILS: 'LISTING_DETAILS'
};
exports.CONTEXTS = CONTEXTS;
var VALUES = {
  CATEGORY: 'CATEGORY'
};
exports.VALUES = VALUES;
var APPLICATION_NAME = 'appcenter';
exports.APPLICATION_NAME = APPLICATION_NAME;
var elementList = {
  button: 'button',
  link: 'link',
  menuItem: 'menuitem'
};
exports.elementList = elementList;
var actionList = {
  click: 'click'
};
exports.actionList = actionList;
var termsAndConditions = 'Terms and Conditions Panel';
exports.termsAndConditions = termsAndConditions;
var button = {
  accept: 'accept',
  cancel: 'cancel',
  connect: 'connect',
  disconnect: 'disconnect',
  enroll: 'enroll',
  unenroll: 'unenroll',
  yes: 'yes',
  no: 'no',
  x: 'close'
};
exports.button = button;
var modal = {
  enroll: 'enroll modal',
  unenroll: 'unenroll modal',
  disconnect: 'disconnect modal'
};
exports.modal = modal;
var connectLoyaltyNumber = 'Connect Loyalty Number section';
exports.connectLoyaltyNumber = connectLoyaltyNumber;
var needAnAccountLink = 'Need an Account Link';
exports.needAnAccountLink = needAnAccountLink;
var learnMoreSharedInfoLink = 'Learn more about the services and fields exposed.';
exports.learnMoreSharedInfoLink = learnMoreSharedInfoLink;
var ReqInfo = 'Request Information';
exports.ReqInfo = ReqInfo;
var launchTAndC = 'Launch Terms and Conditions Panel';
exports.launchTAndC = launchTAndC;
var connectWithoutTAndC = 'Connect without launching Terms and Conditions Panel';
exports.connectWithoutTAndC = connectWithoutTAndC;
var listingConst = 'listing';
exports.listingConst = listingConst;
var categoryDropdown = 'Category Dropdown Menu Option';
exports.categoryDropdown = categoryDropdown;


//////////////////
// WEBPACK FOOTER
// ./lib/constants/analytics.js
// module id = 12
// module chunks = 0